import { useState } from "react";
import {
    PieChart,
    Pie,
    Cell,
    ResponsiveContainer,
} from "recharts";
import { Box, Typography } from "@mui/material";

const CATEGORY_COLORS = {
    "Books": "#FFD700",
    "Board/Medical Certifications": "#6A1B9A",
    "Resuscitation Certifications": "#8B0000",
    "Conferences": "#1E90FF",
    "Medical Journals": "#9B59B6",
    "Medical License": "#2ECC71",
    "Medical Society Membership Dues": "#F39C12",
    "Phone Applications": "#00BFFF",
    "Web-based/Online Applications": "#7D3C98",
    "Podcasts": "#E67E22",
    "Medical Equipment": "#A569BD",
    "Medical Clothing": "#5DADE2",
    "Cell Phone": "#F1C40F",
    "Internet": "#3498DB",
    "Office Equipment": "#2E86C1",
    "Workshops & Seminars": "#58D68D",
    "Online Modules/CME Courses": "#F4D03F",
    "Educational Program": "#D35400",
    "TSA Precheck": "#27AE60",
    "Global Entry": "#16A085",
    "Travel": "#E91E63",
    "Remaining": "#BDBDBD"
};

export default function FundPieChart({
    categoryBreakdown = [],
    remaining
}) {
    const [hoveredCategory, setHoveredCategory] = useState(null);

    const chartData = categoryBreakdown
        .filter((item) => item.value > 0)
        .map((item) => ({
            ...item,
            color: CATEGORY_COLORS[item.name.trim()] || "#888"
        }));

    if (remaining > 0) {
        chartData.push({
            name: "Remaining",
            value: remaining,
            color: CATEGORY_COLORS["Remaining"]
        });
    }

    const handleMouseEnter = (_, index) => {
        setHoveredCategory(chartData[index]);
    };

    const handleMouseLeave = () => {
        setHoveredCategory(null);
    };

    // Calculate percentage for the hovered category
    const total = chartData.reduce((acc, item) => acc + item.value, 0);
    const percentage = hoveredCategory
        ? Math.round((hoveredCategory.value / total) * 100)
        : 0;

    return (
        <Box sx={{ position: "relative", textAlign: "center" }}>
            <ResponsiveContainer width={350} height={350}>
                <PieChart>
                    <Pie
                        data={chartData}
                        cx="50%"
                        cy="50%"
                        innerRadius={90}
                        outerRadius={120}
                        dataKey="value"
                        paddingAngle={0}
                        stroke="none"
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        {chartData.map((entry, index) => (
                            <Cell
                                key={`slice-${index}`}
                                fill={entry.color}
                                cursor="pointer"
                                opacity={hoveredCategory && hoveredCategory.name !== entry.name ? 0.6 : 1}
                            />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>

            {/* Center content - shows hovered category or default message */}
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    textAlign: "center",
                    pointerEvents: "none",
                }}
            >
                {hoveredCategory ? (
                    <>
                        <Typography variant="h6" fontWeight="600" color="text.primary">
                            {hoveredCategory.name}
                        </Typography>
                        <Typography variant="h5" fontWeight="700" color="text.primary" mt={0.5}>
                            ${hoveredCategory.value.toFixed(0)}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {percentage}%
                        </Typography>
                    </>
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        Hover to view category
                    </Typography>
                )}
            </Box>
        </Box>
    );
}
